module.exports = __webpack_public_path__ + "img/light.6a72ba6f.png";